var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('h3',{staticStyle:{"margin-top":"0","margin-bottom":"5px"}},[_vm._v("Поиск "+_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }